<script setup>
import moment from "moment";
import axios  from "axios";
import Message from "@/components/common/Message.vue";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-dialog
        v-model="selectedOpen"
        width="850px"
        id="events"
    >
        <v-card>
          <v-card
            min-width="850px"
            max-width="850px"
            flat
          >
            <v-toolbar
              :color="selectedEvent.color"
              tile
              flat
              dark
               v-if="edit_flg==false"
              dense
            >
              <v-toolbar-title>{{selectedEvent.name }}</v-toolbar-title>
             <v-spacer></v-spacer>
              <v-btn 
                @click="editMode"
              icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn 
                @click="deleteEvent"
              icon>
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn 
                @click="selectedOpen=false"
              icon>
                <v-icon
                @click="selectedOpen=false"
                >mdi-close</v-icon>
              </v-btn>

            </v-toolbar>
            <v-toolbar
                height="50px"
                tile
                flat
                :color="color[category_get(selected_cat)]"
                dark
                v-else
            >
             <v-spacer></v-spacer>
             <v-switch
                v-model="calswitch"
                label="Googleカレンダーと連携"
                hide-details
                v-if="this.cal_flg==true"
                class="mr-2"
              ></v-switch>
                <v-icon
                @click="editor_close"
                >mdi-close</v-icon>
            </v-toolbar>

            <v-card-text
                 v-if="edit_flg"
               class="py-0"
            >
                <v-text-field
                  label="予定の名称"
                  hide-details="auto"
                  v-model="name"
                  :value = "name"
                  class="pt-3"
                  outlined
                ></v-text-field>
            </v-card-text>
            <v-card-text 
               v-if="edit_flg"
               class="pt-0 pb-1"
            >
              <v-row
                no-gutters
              >
                <v-col cols="8" class="pr-2">
                  <v-menu
                    v-model="start_date_area"
                    :close-on-content-click="close_on"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    z-index="5000000"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="start_date"
                        label="開始日時"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="start_date"
                      @input="start_date_area = false"
                      no-title
                      locale="jp-ja"
                      :day-format="(date) => new Date(date).getDate()"
                    ></v-date-picker>
                  </v-menu>
                  <v-menu
                    v-model="end_date_area"
                    :close-on-content-click="close_on"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    z-index="5000000"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="end_date"
                        label="終了日時"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="end_date"
                      @input="end_date_area = false"
                      no-title
                      locale="jp-ja"
                      :day-format="(date) => new Date(date).getDate()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4">
                    <v-select
                      v-model="start_time"
                      :items="timetable"
                      :disabled="time_disable"
                    ></v-select>
                    <v-select
                      v-model="end_time"
                      :items="timetable"
                      :disabled="time_disable"
                    ></v-select>
                </v-col>
                </v-row>
            </v-card-text>
            <v-card-text 
                v-if="edit_flg"
               class="pt-0 pb-1"
            >
                <v-row no-gutter>
                    <v-col cols="2">
                        <div style="position:relative;height:100%">
                            <div style="position:absolute;top:20%;">
                            <v-switch
                                v-model="timed"
                                label="時間指定"
                                class="mt-0"
                            ></v-switch>
                            </div>
                        </div>
                    </v-col>

                    <v-col v-if="pay_flg==true">
                        <v-select
                            v-model="selected_pro"
                            :items="project"
                            item-text="text"
                            item-value="val"
                            attach
                            label="プロジェクト"
                            class="pt-1"
                            chips
                            multiple
                        ></v-select>
                    </v-col>
                    <v-col cols="3">
                        <v-select
                            v-model="selected_cat"
                            :items="category"
                            attach
                            label="カテゴリ"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text 
                v-if="edit_flg"
               class="pt-0 pb-1"
            >
                <v-text-field
                  label="場所"
                  hide-details="auto"
                  prepend-icon="mdi-map-marker-outline"
                  v-model = "place"
                  :value = "place"
                  class="mt-0 pt-0"
                  outlined
                  dense
                  v-if="place_flg==true"
                ></v-text-field>
                <v-textarea
                  clearable
                  prepend-icon="mdi-comment"
                  clear-icon="mdi-close-circle"
                  label="概要"
                  auto-grow
                  v-model="summary"
                  dense
                  outlined
                  class="mt-3"
                ></v-textarea>
            </v-card-text>
            <v-card-text v-else>
                <v-container>

                <span class="datearea">{{ moment(selectedEvent.start).format("YYYY年MM月DD日HH:mm") }}〜{{moment(selectedEvent.end).format("YYYY年MM月DD日HH:mm")}}</span>
                 <v-select
                    v-model="selected_cat"
                    :items="category"
                    attach
                    label="カテゴリ"
                    disabled
                 ></v-select>
                <v-row
                    no-gutters
                    v-if="place_flg==true"
                    style="font-size:1.5rem!important"
                >
                    <v-col cols="1" style="text-alilgn:center">        
                        <v-icon>
                            mdi-map-marker-outline
                        </v-icon>
                    </v-col>
                    <v-col cols="11" class="pt-1" v-if="place != ''">
                        {{ place }}
                    </v-col>
                    <v-col cols="11" class="pt-1" v-else>
                        場所指定なし
                    </v-col>
                </v-row>
                <v-row
                    no-gutters
                    v-if="press_flg==true"
                    class="press_area"
                >
                    <v-col class="pt-1" v-if="selectedEvent.doc_id != '' && selectedEvent.doc_id != null">
                        <span v-if="selectedEvent.rel_title!=''">
                            {{ selectedEvent.rel_title }}
                        </span>
                        <span v-else>
                            名称未設定
                        </span>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    @click="rel_edit()"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>編集する</span>
                        </v-tooltip>
                    </v-col>
                    <v-col class="py-3" v-else>
                        <span class="ecreate">
                            <v-btn @click="rel_edit">プレスリリースを新規作成</v-btn>
                        </span>
                    </v-col>
                    <v-col cols="3"
                        v-if="selectedEvent.doc_id != '' && selectedEvent.doc_id != null"
                    >
                        <v-btn
                            @click="rel_dl(selectedEvent.doc_id)"
                            color="#E13532"
                            dark
                        >
                            <v-icon
                            >
                                mdi-download
                            </v-icon>
                            ダウンロード
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    style="font-size:1.5rem!important"
                >
                    <v-col cols="1">        
                        <v-icon>
                            mdi-text-long
                        </v-icon>
                    </v-col>
                    <v-col cols="11" class="pt-2 mt-2" v-html="summary_dsp()">
                    </v-col>
                  </v-row>
                  <v-row class="mt-5 pl-3 pr-3">
              <v-select
                v-model="selected_pro"
                :items="project"
                item-text="text"
                item-value="val"
                attach
                disabled
                dense
                label="プロジェクト"
                chips
                multiple
              ></v-select>
              </v-row>


                </v-container>
            </v-card-text>
            <v-card-actions
                class="pt-0"
                 v-if="edit_flg"
            >
                <v-spacer></v-spacer>
                  <v-btn
                    color="#E34749"
                    @click="saveEvent"
                    :disabled ="button_flg"
                    :dark="!button_flg"
                  >
                    保存
                  </v-btn>

                  <v-btn
                    color="#E34749"
                    dark
                    @click="editor_close"
                  >
                    Cancel
                  </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-card>
        <Message 
            ref="message" 
            title="Googleカレンダーに予定を追加しますか？"
            message="Googleカレンダーと連携していると本予定をGoogleカレンダーからも閲覧できます。スケジュール情報以外は連携されません。" 
            v-on:messcancel="google_cancel"
        />
        </v-dialog>
</template>
<script>
export default {
    props: ["dsptype","project"],
    computed : {
        cal_flg : function(){
            return this.$store.getters["member_info/get_cal_flg"]
        },
		pay_flg : function(){
			return this.$store.getters["member_info/get_pay_flg"];
		},
    },
    data: () => ({
      moment       : null,
      calswitch : false,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      veiwarea : false,
      clx      :0,
      cly      :0,
      edit_flg : false,
      close_on : false,
      start_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      start_time: '',
      end_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      end_time: '',
      timed   : 1,
      name    : '',
      place   : '',
      place_flg : true,
        press_flg : false,
        setevdata : null,
      start_date_area: false,
      start_time_area: false,
      end_date_area: false,
      time_disable  : false,
      summary : '',
      dsp_summary : '',
      timetable : [],
      category: ['タスク','取材','イベント','プレスリリース','その他'],
      color: ['#08415C','#42BFDD','#8380B6','#4FB477','#4A2040'],
      selected_cat : "その他",
      selected_pro : [],
      button_flg   : true,
    }),
    watch:{
        calswitch : function(){
            if(this.calswitch == true)
            {
                this.$refs.message.opendl();
            }
        },
        edit_flg : function(){
            this.editStatus();
        },
        selected_cat : function(){
            if(this.selected_cat=="プレスリリース")
            {
                this.place_flg=false;
                this.press_flg = true;
            }
            else
            {
                this.place_flg=true;
                this.press_flg = false;
            }
            this.editStatus();
        },
        menu: function(){
        },
        start_date : function(){
            this.end_date = this.start_date;
            if(!this.edit_flg)
                return;
            this.editStatus();
        },
        start_time : function()
        {
            if(moment(this.start_date + " " + this.start_time) < moment(this.end_date + " " + this.end_time))
                return;
            let tmp_end_date = moment(this.start_date + " " +  this.start_time).add(30, 'm').format();
            this.end_date = moment(tmp_end_date).format("YYYY-MM-DD");
            this.end_time = moment(tmp_end_date).format("HH:mm");
            if(!this.edit_flg)
                return;
            this.editStatus();
        },
        end_date : function(){
            if(!this.edit_flg)
                return;
            this.editStatus();
        },
        end_time : function(){
            if(!this.edit_flg)
                return;
            this.editStatus();
        },
        
        timed : function(){
            if(this.timed == true)
            {
                this.time_disable = false;
            }
            else
            {
                this.time_disable = true;
            }
        },
        name : function(){
            if(this.name != '')
            {
                this.button_flg=false;
            }
            else
            {
                this.button_flg=true;
            }
        },
        selectedOpen : function(){
            if(!this.selectedOpen)
                this.edit_flg=false;
        },
    },
    methods: {
		google_cancel : function(){
			this.calswitch = false;
		},
      google_set : async function(){
            await axios.post("https://docs.qlipper.jp/gcal/",this.setevdata)
            .then(() => {
            });
      },
      style_str : function(){
         let top = 12;
         if(this.cly != 0)
            top = this.cly;
          return "top:" +top+ "px!important";
      },
      editStatus(){
        this.$emit("edit-event",{
            edit_flg:this.edit_flg,
            start:moment(this.start_date+" "+this.start_time).format('YYYY-MM-DD HH:mm'),
            end:moment(this.end_date+" "+this.end_time).format('YYYY-MM-DD HH:mm'),
            category_color : this.color[this.category_get(this.selected_cat)],
        });
        this.$nextTick(function() {
            let elem = document.querySelector(".v-menu__content");
            if(elem == null)
                return;
            if(this.edit_flg==true)
            {
                elem.style.top="-30px";
            }
            else
            {
                elem.style.top="100px";
            }
        });

      },
      rel_edit    : function(){
        //this.$emit("editor-open",this.selectedEvent);
        //this.$router.push({name: 'Edit', params: {sch_id: this.sch_id}});
        this.$router.push({name: 'Edit', params: {selected_id:this.selectedEvent.doc_id,sch_id: this.selectedEvent.id}});
      },
      rel_dl    : function(doc_id){
        this.$emit("rel-dl",{doc_id:doc_id});
      },
      summary_dsp : function(){
        let str = "";
        if(this.summary != null && this.summary != "")
            str = this.summary.replaceAll("\n","<br />");
        else
            str = "概要記入なし";
        return str;
      },
      editor_close(){
        this.edit_flg=false;
        this.selectedOpen=false;
      },
      category_get : function (cat){
        let num = 0;

        for(num = 0 ; num < this.category.length ; num++)
        {
            if(cat == this.category[num])
            {
                break;
            }
        }
        return num;
      },
      editMode(){
        this.edit_flg=true;
      },
      async saveEvent(){
        const start = this.start_date + " " + this.start_time;
        const end = this.end_date + " " + this.end_time;
        const save_event = { 
            name  : this.name,
            place : this.place,
            id    : this.selectedEvent.id,
            start : start,
            end: end,
            timed  : this.timed,
            category : this.selected_cat ,
            project : this.selected_pro ,
            summary : this.summary ,
        };
        var params = new URLSearchParams();
        params.append('evdata',JSON.stringify(save_event));
    
        await axios.post("https://qlipper.jp/api/events/setEvent",params,)
        .then(response => {
            save_event.id = response.data;
            this.setevdata = save_event;
            this.$emit('add-event',{"save_event":save_event});
            this.selectedOpen = false;
            if(this.calswitch==true)
                this.google_set();
            //this.$refs.message.opendl();
        });
      },
      showDial(event){
        this.edit_flg=false;
        this.selectedOpen = false;

        this.selectedEvent = {name:'',id:'',timed:true};
        this.selectedElement = document.querySelector('.calbox');
        this.clx=0;
        this.cly="12.px";
        if( event.date == undefined ){
              this.start_date = moment().format("YYYY-MM-DD");
              this.end_date   = moment().format("YYYY-MM-DD");
            this.start_time = moment().format("HH:00");
            this.end_time = moment().format("HH:30");
        }
        else{
            this.start_date = moment(event.date).format('YYYY-MM-DD');
            this.end_date   = moment(event.date).format('YYYY-MM-DD');
            if(event.hasTime==true)
            {
                this.start_time=moment(this.start_date + " " + event.time).format('HH:00');
                this.end_time  =moment(this.start_date + " "+ this.start_time).add(30, 'm').format('HH:00');
            }
            else
            {
                this.start_time = moment().format("HH:00");
                this.end_time = moment().format("HH:30");
            }
        }
        this.timed=true;
        this.name='';
        this.place='';
        this.summary='';
        if(event.category == undefined)
        {
              this.selected_cat="その他";
        }
        else
        {
            this.selected_cat = event.category;
        }
          this.selected_pro=[];

        this.edit_flg = true;
        this.$nextTick(() => {
          this.selectedOpen = true
        });
        //requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true));
      },
      deleteEvent(){
        var params = new URLSearchParams();
        params.append('id', this.selectedEvent.id);

        if(confirm("イベント情報を削除します。よろしいですか？") == false)
        {
            this.selectedOpen = false;
            return false;
        }

        axios.post("https://qlipper.jp/api/events/del_events.php",params)
        .then(response => {
            let status = response.data;
            status;
            this.$emit('add-event',{"save_event":null});
            this.selectedOpen = false;
        });
      },
      showEvent(nativeEvent,event) {
        this.edit_flg=false;
        //let head_class=".v-calendar-weekly__head-weekday";

        this.clx=0;
        this.cly=0;

        /*
        if(this.dsptype == 'week')
        {
            head_class=".v-calendar-daily_head-weekday";
        }
        else if(this.dsptype == 'day')
        {
            head_class=".v-calendar-daily__head";
        }
        
        let selectedElement = document.querySelector(head_class);
        var winwidth = window.innerWidth;
        let dialogsize = 350 + 20 ;
        if(winwidth - (nativeEvent.clientX-nativeEvent.offsetX+selectedElement.clientWidth) < dialogsize)
        {
            this.viewarea = true;
            this.clx      = (nativeEvent.clientX - nativeEvent.offsetX) -  dialogsize ;
        }
        else
        {
            this.clx = (nativeEvent.clientX - nativeEvent.offsetX) + selectedElement.clientWidth +20;
            this.viewarea = false;
        }
        let rec = document.querySelector('.calbox').getBoundingClientRect();
        this.cly = rec.top + 100;
        */

        const open = () => {
          this.selectedEvent = event;
          this.start_date = moment(this.selectedEvent.start).format("YYYY-MM-DD");
          this.end_date = moment(this.selectedEvent.end).format("YYYY-MM-DD");
          this.start_time = moment(this.selectedEvent.start).format("HH:mm");
          this.end_time = moment(this.selectedEvent.end).format("HH:mm");
          this.name = this.selectedEvent.name;
          this.timed = this.selectedEvent.timed;
          this.place = this.selectedEvent.place;
          this.selected_cat = this.selectedEvent.category;
          this.selected_pro = this.selectedEvent.project;
          this.summary = this.selectedEvent.summary;

          this.selectedElement = nativeEvent.target;
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        this.$nextTick(() => {
            if (this.selectedOpen) {
                  this.selectedOpen = false
                  requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                  open()
            }
            nativeEvent.stopPropagation()
        });

     },
    },
    created : function(){
        const min_array = ["00","15","30","45"];
        for(let i=0 ; i < 24 ; i++)
        {
            for(let ci = 0 ; ci < min_array.length ; ci++)
                this.timetable.push(( '00' + i ).slice( -2 )+":"+ min_array[ci]);
        }
    },
}
</script>
<style>
.ecreate{
    font-weight : 300;
}
.press_area{
    font-size:1.5rem;
}


.datearea{
    font-size:2rem;
    font-weight : bold;
}
</style>
